import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mt-2" }

import {ref} from 'vue';
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import openClientById from "~/operatorApplication/ts/service/buddyList/openClientById";
import OpenClientByIdExposeInterface from "~/operatorApplication/vue/dialogs/OpenClientByIdExposeInterface";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "OpenClientById"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

let emits = __emit;

let input = ref<HTMLInputElement>(null);
let value = ref<string>();

async function search() {
    if (value.value) {
        if (await openClientById(value.value)) {
            emits("close");
        }
    }
}

function focusInput() {
    setTimeout(() => {
        input.value.focus();
    }, 100);
}

__expose<OpenClientByIdExposeInterface>({
    focusInput
});


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, [
        _createVNode(FontAwesomeIcon, { icon: "hashtag" }),
        _createTextVNode(" " + _toDisplayString(_unref(__)("Идентификатор клиента")), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createVNode(_component_el_input, {
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : value = $event)),
        placeholder: "123456789",
        class: "w-100",
        ref_key: "input",
        ref: input
      }, null, 8, ["modelValue"]), [
        [
          _directive_on_native,
          search,
          "keydown",
          { enter: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: "w-100",
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)("Найти")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})